import { elevations } from '@getgo/chameleon-core';
import { Tooltip } from '@getgo/chameleon-material-ui';
import { withStyles } from '@material-ui/core';
export default withStyles(() => ({
    popper: {
        pointerEvents: 'initial',
    },
    tooltip: {
        backgroundColor: 'var(--goto-ui-01)',
        border: '1px solid var(--goto-border)',
        boxShadow: elevations['elevation-100'],
        color: 'var(--goto-text-01)',
        fontSize: 14,
        padding: 12,
        width: 240,
    },
    arrow: {
        color: 'var(--goto-ui-01)',
        '&::before': {
            border: '1px solid var(--goto-border)',
        },
    },
}))(Tooltip);
//# sourceMappingURL=index.js.map